module.exports = __webpack_public_path__ + "e7a9463713b09f580cf6211a53a88b99.svg";